import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-be56e12c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "send-property-offers-content" }
const _hoisted_2 = { class: "info-box-container" }
const _hoisted_3 = { class: "column" }
const _hoisted_4 = { class: "column" }
const _hoisted_5 = { class: "column" }
const _hoisted_6 = { class: "grid-container" }
const _hoisted_7 = { class: "custom-cell" }
const _hoisted_8 = { class: "custom-cell" }

import { computed, inject, ref, watch } from "vue";
import ModalBase from "@/components/ui/modals/modal-base.vue";
import { DxToolbarItem } from "devextreme-vue/popup";
import GridBase from "@/components/ui/grid/grid-base.vue";
import { DxColumn } from "devextreme-vue/data-grid";
import AcquaintInfoBox from "../ui/inputs/acquaint-info-box.vue";
import SwitchToggle from "@/components/ui/toggles/switch-toggle.vue";
import { AcquaintApiClient } from "@/services/AcquaintApiClient";
import { AcquaintApiNextClient } from "@/services/AcquaintApiNextClient";
import displayErrorMessage from "@/utils/ErrorHandling";
import { getErrorMessage } from "bright-logic-core/src/errors";
import { SMSCredits } from "@/types/sms/SMSCredits";
import { PropertyCategories } from "@/enums/properties/PropertyCategories";
import { useSystemConfigurationStore } from "@/stores/SystemConfigurationStore";
import { SystemConfiguration } from "acquaint-api/constants/SystemConfiguration";
import { SendOffer } from "@/types/offers/SendOffer";
import { SendOfferContact } from "@/types/offers/SendOfferContact";
import EmailFormModal from "../email/email-form-modal.vue";
import SMSForm from "../sms/sms-form.vue";
import EmailTemplatesConfigurationModal from "../email/email-templates-configuration-modal.vue";
import SmsTextsConfigurationTemplates from "../sms-texts-configuration-templates.vue";
import { OfferStatus } from "@/enums/property-offers/OfferStatus";
import { ModalWidth } from "@/types/ui/modals/ModalWidth";
import { FieldSize } from "@/enums/system/FieldSize";
import { LookupTableSource } from "acquaint-api/constants/LookupTableSource";
import { useLookupConfigurationStore } from "@/stores/LookupConfigurationStore";
import { OfferContactType } from "@/enums/contacts/OfferContactType";


export default /*#__PURE__*/_defineComponent({
  __name: 'send-offers-modal',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
  /**
   * The offer id used to fetch the appropriate data.
   * @type {number}
   * @required
   */
  id: {
    type: Number,
    required: true,
  },
  /**
   * The category of the property associated with the offer used to get the correct templates.
   * @type {number}
   * @required
   */
  propertyCategory: {
    type: Number,
    required: true,
  },
  /**
   * The status of the offer used to get the correct templates.
   * @type {number}
   * @required
   */
  offerStatus: {
    type: Number,
    required: true,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",
],
  setup(__props, { emit }) {

const props = __props;





const showModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

const lookupConfigurationStore = useLookupConfigurationStore();
const apiClient = inject("AcquaintApiClient") as AcquaintApiClient;
const apiNextClient = inject("AcquaintApiNextClient") as AcquaintApiNextClient;
const contacts = ref<SendOfferContact[]>([]);
const emailCredits = ref(0);
const smsCredits = ref(0);
const dropdownIcon = ref("fa-sharp fa-solid fa-caret-down");
const purchaserEmailTemplate = ref("");
const vendorEmailTemplate = ref("");
const purchaserSMSTemplate = ref("");
const vendorSMSTemplate = ref("");
const purchaserEmailTemplateId = ref("");
const vendorEmailTemplateId = ref("");
const purchaserSMSTemplateId = ref("");
const vendorSMSTemplateId = ref("");
const systemConfigurationStore = useSystemConfigurationStore();
const previewEmailSMS = ref(false);
const displayPurchaserEmailModal = ref(false);
const displayVendorEmailModal = ref(false);
const displayPurchaserSMSModal = ref(false);
const displayVendorSMSModal = ref(false);
const displaySMSTemplatesModal = ref(false);
const displayEmailTemplatesModal = ref(false);
const willEmail = computed(() => {
  return (
    contacts.value.length > 0 &&
    contacts.value.some((contact) => contact.sendEmail)
  );
});
const willText = computed(() => {
  return (
    contacts.value.length > 0 &&
    contacts.value.some((contact) => contact.sendSms)
  );
});
const updatePurchaserEmailTemplate = ref(false);
const updatePurchaserSMSTemplate = ref(false);
const purchaserEmailContactIds = computed(() => {
  return contacts.value
    .filter((contact) => {
      return (
        contact.offerContactType == OfferContactType.Purchaser &&
        contact.sendEmail
      );
    })
    .map((contact) => {
      return contact.contactId;
    });
});
const vendorEmailContactIds = computed(() => {
  return contacts.value
    .filter((contact) => {
      return (
        contact.offerContactType == OfferContactType.Vendor && contact.sendEmail
      );
    })
    .map((contact) => {
      return contact.contactId;
    });
});
const purchaserSMSContactIds = computed(() => {
  return contacts.value
    .filter((contact) => {
      return (
        contact.offerContactType == OfferContactType.Purchaser &&
        contact.sendSms
      );
    })
    .map((contact) => {
      return contact.contactId;
    });
});
const vendorSMSContactIds = computed(() => {
  return contacts.value
    .filter((contact) => {
      return (
        contact.offerContactType == OfferContactType.Vendor && contact.sendSms
      );
    })
    .map((contact) => {
      return contact.contactId;
    });
});

// Fetch data
const fetchContactList = async () => {
  try {
    contacts.value = await apiClient.httpGet(`app/sendoffers/${props.id}`);
  } catch (err) {
    contacts.value = [];
    displayErrorMessage(getErrorMessage(err));
  }
};

const getEmailCredits = async () => {
  try {
    emailCredits.value = await apiNextClient.httpGet(
      "/Email/getemailcreditbalance",
    );
  } catch (err) {
    emailCredits.value = 0;
    displayErrorMessage(getErrorMessage(err));
  }
};

const fetchSmsCredits = async () => {
  try {
    const rawCredits = await apiClient.httpGet<SMSCredits>(
      "app/correspondence/sms/credits",
    );
    smsCredits.value = rawCredits.total;
  } catch (err) {
    smsCredits.value = 0;
    displayErrorMessage(getErrorMessage(err));
  }
};

watch(
  () => showModal.value,
  async () => {
    if (!showModal.value) {
      return;
    }

    const previewTextValue =
      await systemConfigurationStore.getSystemConfigurationValue(
        SystemConfiguration.PreviewBeforeSendingPropertyOffers,
      );
    previewEmailSMS.value = previewTextValue == "true" ? true : false;
    fetchContactList();
    getEmailCredits();
    fetchSmsCredits();
    fetchEmailTemplateById();
  },
);

// The template field values are set
const fetchEmailTemplateById = async () => {
  switch (props.offerStatus) {
    case OfferStatus.Pending:
      vendorEmailTemplateId.value =
        await systemConfigurationStore.getSystemConfigurationValue(
          SystemConfiguration.NewPropertyOfferVendorEmailTemplate,
        );
      vendorSMSTemplateId.value =
        await systemConfigurationStore.getSystemConfigurationValue(
          SystemConfiguration.NewPropertyOfferVendorSMSTemplate,
        );

      if (props.propertyCategory == PropertyCategories.Rent) {
        purchaserEmailTemplateId.value =
          await systemConfigurationStore.getSystemConfigurationValue(
            SystemConfiguration.NewPropertyOfferTenantEmailTemplate,
          );
        purchaserSMSTemplateId.value =
          await systemConfigurationStore.getSystemConfigurationValue(
            SystemConfiguration.NewPropertyOfferTenantSMSTemplate,
          );
      } else if (props.propertyCategory == PropertyCategories.Buy) {
        purchaserEmailTemplateId.value =
          await systemConfigurationStore.getSystemConfigurationValue(
            SystemConfiguration.NewPropertyOfferPurchaserEmailTemplate,
          );
        purchaserSMSTemplateId.value =
          await systemConfigurationStore.getSystemConfigurationValue(
            SystemConfiguration.NewPropertyOfferPurchaserSMSTemplate,
          );
      }
      break;
    case OfferStatus.Accepted:
      vendorEmailTemplateId.value =
        await systemConfigurationStore.getSystemConfigurationValue(
          SystemConfiguration.PropertyOfferAcceptedVendorEmailTemplate,
        );
      vendorSMSTemplateId.value =
        await systemConfigurationStore.getSystemConfigurationValue(
          SystemConfiguration.PropertyOfferAcceptedVendorSMSTemplate,
        );

      if (props.propertyCategory == PropertyCategories.Rent) {
        purchaserEmailTemplateId.value =
          await systemConfigurationStore.getSystemConfigurationValue(
            SystemConfiguration.PropertyOfferAcceptedTenantEmailTemplate,
          );
        purchaserSMSTemplateId.value =
          await systemConfigurationStore.getSystemConfigurationValue(
            SystemConfiguration.PropertyOfferAcceptedTenantSMSTemplate,
          );
      } else if (props.propertyCategory == PropertyCategories.Buy) {
        purchaserEmailTemplateId.value =
          await systemConfigurationStore.getSystemConfigurationValue(
            SystemConfiguration.PropertyOfferAcceptedPurchaserEmailTemplate,
          );
        purchaserSMSTemplateId.value =
          await systemConfigurationStore.getSystemConfigurationValue(
            SystemConfiguration.PropertyOfferAcceptedPurchaserSMSTemplate,
          );
      }
      break;
    case OfferStatus.Rejected:
      vendorEmailTemplateId.value =
        await systemConfigurationStore.getSystemConfigurationValue(
          SystemConfiguration.PropertyOfferRejectedVendorEmailTemplate,
        );
      vendorSMSTemplateId.value =
        await systemConfigurationStore.getSystemConfigurationValue(
          SystemConfiguration.PropertyOfferRejectedVendorSMSTemplate,
        );

      if (props.propertyCategory == PropertyCategories.Rent) {
        purchaserEmailTemplateId.value =
          await systemConfigurationStore.getSystemConfigurationValue(
            SystemConfiguration.PropertyOfferRejectedTenantEmailTemplate,
          );
        purchaserSMSTemplateId.value =
          await systemConfigurationStore.getSystemConfigurationValue(
            SystemConfiguration.PropertyOfferRejectedTenantSMSTemplate,
          );
      } else if (props.propertyCategory == PropertyCategories.Buy) {
        purchaserEmailTemplateId.value =
          await systemConfigurationStore.getSystemConfigurationValue(
            SystemConfiguration.PropertyOfferRejectedPurchaserEmailTemplate,
          );
        purchaserSMSTemplateId.value =
          await systemConfigurationStore.getSystemConfigurationValue(
            SystemConfiguration.PropertyOfferRejectedPurchaserSMSTemplate,
          );
      }
      break;
    case OfferStatus.Withdrawn:
      vendorEmailTemplateId.value =
        await systemConfigurationStore.getSystemConfigurationValue(
          SystemConfiguration.PropertyOfferWithdrawnVendorEmailTemplate,
        );
      vendorSMSTemplateId.value =
        await systemConfigurationStore.getSystemConfigurationValue(
          SystemConfiguration.PropertyOfferWithdrawnVendorSMSTemplate,
        );

      if (props.propertyCategory == PropertyCategories.Rent) {
        purchaserEmailTemplateId.value =
          await systemConfigurationStore.getSystemConfigurationValue(
            SystemConfiguration.PropertyOfferWithdrawnTenantEmailTemplate,
          );
        purchaserSMSTemplateId.value =
          await systemConfigurationStore.getSystemConfigurationValue(
            SystemConfiguration.PropertyOfferWithdrawnTenantSMSTemplate,
          );
      } else if (props.propertyCategory == PropertyCategories.Buy) {
        purchaserEmailTemplateId.value =
          await systemConfigurationStore.getSystemConfigurationValue(
            SystemConfiguration.PropertyOfferWithdrawnPurchaserEmailTemplate,
          );
        purchaserSMSTemplateId.value =
          await systemConfigurationStore.getSystemConfigurationValue(
            SystemConfiguration.PropertyOfferWithdrawnPurchaserSMSTemplate,
          );
      }
      break;
    case OfferStatus.AwaitingProof:
      vendorEmailTemplateId.value =
        await systemConfigurationStore.getSystemConfigurationValue(
          SystemConfiguration.PropertyOfferAwaitingProofVendorEmailTemplate,
        );
      vendorSMSTemplateId.value =
        await systemConfigurationStore.getSystemConfigurationValue(
          SystemConfiguration.PropertyOfferAwaitingProofVendorSMSTemplate,
        );

      if (props.propertyCategory == PropertyCategories.Rent) {
        purchaserEmailTemplateId.value =
          await systemConfigurationStore.getSystemConfigurationValue(
            SystemConfiguration.PropertyOfferAwaitingProofTenantEmailTemplate,
          );
        purchaserSMSTemplateId.value =
          await systemConfigurationStore.getSystemConfigurationValue(
            SystemConfiguration.PropertyOfferAwaitingProofTenantSMSTemplate,
          );
      } else if (props.propertyCategory == PropertyCategories.Buy) {
        purchaserEmailTemplateId.value =
          await systemConfigurationStore.getSystemConfigurationValue(
            SystemConfiguration.PropertyOfferAwaitingProofPurchaserEmailTemplate,
          );
        purchaserSMSTemplateId.value =
          await systemConfigurationStore.getSystemConfigurationValue(
            SystemConfiguration.PropertyOfferAwaitingProofPurchaserSMSTemplate,
          );
      }
      break;
  }

  fetchTemplateTextValues(
    vendorEmailTemplateId.value,
    vendorSMSTemplateId.value,
    purchaserEmailTemplateId.value,
    purchaserSMSTemplateId.value,
  );
};

const fetchTemplateTextValues = async (
  vendorEmail: string,
  vendorSMS: string,
  purchaserEmail: string,
  purchaserSMS: string,
) => {
  vendorEmailTemplate.value =
    await lookupConfigurationStore.getLookupConfigurationDescription(
      LookupTableSource.EmailTemplates,
      Number(vendorEmail),
    );
  purchaserEmailTemplate.value =
    await lookupConfigurationStore.getLookupConfigurationDescription(
      LookupTableSource.EmailTemplates,
      Number(purchaserEmail),
    );
  vendorSMSTemplate.value =
    await lookupConfigurationStore.getLookupConfigurationDescription(
      LookupTableSource.SMSTemplates,
      Number(vendorSMS),
    );
  purchaserSMSTemplate.value =
    await lookupConfigurationStore.getLookupConfigurationDescription(
      LookupTableSource.SMSTemplates,
      Number(purchaserSMS),
    );
};

const onSendClick = async () => {
  const offer: SendOffer = {
    offerId: props.id,
    vendorEmailTemplateId: Number(vendorEmailTemplateId.value),
    vendorSmsTemplateId: Number(vendorSMSTemplateId.value),
    purchaserEmailTemplateId: Number(purchaserEmailTemplateId.value),
    purchaserSmsTemplateId: Number(purchaserSMSTemplateId.value),
    contacts: contacts.value.map((contact) => {
      return {
        contactId: contact.contactId,
        type: contact.type,
        email: contact.email,
        mobile: contact.mobile,
        sendEmail: contact.sendEmail,
        sendSms: contact.sendSms,
        offerContactType: contact.offerContactType,
      };
    }),
  };

  if (!previewEmailSMS.value) {
    await sendOffer(offer);
    showModal.value = false;
    return;
  }

  // We will display the email modals first and then the SMS modals.
  if (willEmail.value) {
    displayEmailPreviewModals();
    return;
  }

  displaySMSPreviewModals();
};

const sendOffer = async (offer: SendOffer) => {
  try {
    await apiNextClient.httpPost("SendOffers", offer);
    return true;
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    return false;
  }
};

// After the purchaser email modal is displayed, the vendor email modal is displayed or the SMS modals.
// Order: purchaser email, vendor email, purchaser SMS, vendor SMS.
const displayEmailPreviewModals = () => {
  if (purchaserEmailContactIds.value.length > 0) {
    displayPurchaserEmailModal.value = true;
  } else if (vendorEmailContactIds.value.length > 0) {
    displayVendorEmailModal.value = true;
  }
};

const displaySMSPreviewModals = () => {
  if (willText.value) {
    if (purchaserSMSContactIds.value.length > 0) {
      displayPurchaserSMSModal.value = true;
    } else if (vendorSMSContactIds.value.length > 0) {
      displayVendorSMSModal.value = true;
    }
  }
};

const purchaserEmailModalClosed = () => {
  if (vendorEmailContactIds.value.length > 0) {
    displayVendorEmailModal.value = true;
    return;
  }

  displaySMSPreviewModals();
};

const vendorEmailModalClosed = () => {
  displaySMSPreviewModals();
};

const purchaserSMSModalClosed = () => {
  if (vendorSMSContactIds.value.length > 0) {
    displayVendorSMSModal.value = true;
  }
};

// When the icon in one of the template fields is selected, we need to display the correct template modal and set the updatePurchaserSMSTemplate or updatePurchaserEmailTemplate ref
// to ensure the right field is updated after a template has been selected.
const emailTemplateSelected = (
  configurationId: number,
  isMarketingTemplate: boolean,
  selectedDescription: string,
) => {
  if (updatePurchaserEmailTemplate.value) {
    purchaserEmailTemplate.value = selectedDescription;
    purchaserEmailTemplateId.value = configurationId.toString();
  } else {
    vendorEmailTemplate.value = selectedDescription;
    vendorEmailTemplateId.value = configurationId.toString();
  }
};

const smsTemplateSelected = (
  configurationId: number,
  isMarketingTemplate: boolean,
  selectedDescription: string,
) => {
  if (updatePurchaserSMSTemplate.value) {
    purchaserSMSTemplate.value = selectedDescription;
    purchaserSMSTemplateId.value = configurationId.toString();
  } else {
    vendorSMSTemplate.value = selectedDescription;
    vendorSMSTemplateId.value = configurationId.toString();
  }
};

const updateSelectedPurchaserEmailTemplate = () => {
  updatePurchaserEmailTemplate.value = true;
  displayEmailTemplatesModal.value = true;
};

const updateSelectedVendorEmailTemplate = () => {
  updatePurchaserEmailTemplate.value = false;
  displayEmailTemplatesModal.value = true;
};

const updateSelectedPurchaserSMSTemplate = () => {
  updatePurchaserSMSTemplate.value = true;
  displaySMSTemplatesModal.value = true;
};

const updateSelectedVendorSMSTemplate = () => {
  updatePurchaserSMSTemplate.value = false;
  displaySMSTemplatesModal.value = true;
};

const onCancelClick = () => (showModal.value = false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ModalBase, {
      modelValue: showModal.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showModal).value = $event)),
      title: "Send Property Offer",
      width: _unref(ModalWidth).Medium,
      height: "600px"
    }, {
      content: _withCtx(() => [
        _createElementVNode("section", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(AcquaintInfoBox, {
                icon: dropdownIcon.value,
                label: "Purchaser Email Template",
                width: _unref(FieldSize).Largeish,
                text: purchaserEmailTemplate.value,
                onIconClicked: updateSelectedPurchaserEmailTemplate
              }, null, 8, ["icon", "width", "text"]),
              _createVNode(AcquaintInfoBox, {
                icon: dropdownIcon.value,
                label: "Vendor Email Template",
                width: _unref(FieldSize).Largeish,
                text: vendorEmailTemplate.value,
                onIconClicked: updateSelectedVendorEmailTemplate
              }, null, 8, ["icon", "width", "text"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(AcquaintInfoBox, {
                icon: dropdownIcon.value,
                label: "Purchaser SMS Template",
                width: _unref(FieldSize).Largeish,
                text: purchaserSMSTemplate.value,
                onIconClicked: updateSelectedPurchaserSMSTemplate
              }, null, 8, ["icon", "width", "text"]),
              _createVNode(AcquaintInfoBox, {
                icon: dropdownIcon.value,
                label: "Vendor SMS Template",
                width: _unref(FieldSize).Largeish,
                text: vendorSMSTemplate.value,
                onIconClicked: updateSelectedVendorSMSTemplate
              }, null, 8, ["icon", "width", "text"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(AcquaintInfoBox, {
                text: emailCredits.value.toString(),
                label: "Email Credits Remaining",
                width: _unref(FieldSize).Medium
              }, null, 8, ["text", "width"]),
              _createVNode(AcquaintInfoBox, {
                text: smsCredits.value.toString(),
                label: "SMS Credits Remaining",
                width: _unref(FieldSize).Medium
              }, null, 8, ["text", "width"]),
              _createVNode(SwitchToggle, {
                class: "span-columns",
                label: "Preview Before Sending",
                modelValue: previewEmailSMS.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((previewEmailSMS).value = $event)),
                readOnly: false,
                "margin-bottom": "0rem"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(GridBase, {
              dataSource: contacts.value,
              "id-column-name": "contactId",
              "column-auto-width": true,
              wordWrapEnabled: true,
              customColumnSlots: ['sendSmsTemplate', 'sendEmailTemplate']
            }, {
              columns: _withCtx(() => [
                _createVNode(_unref(DxColumn), {
                  "data-field": "contact",
                  caption: "Contact",
                  width: "155px",
                  "hiding-priority": 6
                }),
                _createVNode(_unref(DxColumn), {
                  "data-field": "type",
                  caption: "Type",
                  width: "120px",
                  "hiding-priority": 3
                }),
                _createVNode(_unref(DxColumn), {
                  "data-field": "email",
                  caption: "Email",
                  "hiding-priority": 2
                }),
                _createVNode(_unref(DxColumn), {
                  "data-field": "mobile",
                  caption: "Mobile",
                  width: "120px",
                  "hiding-priority": 1
                }),
                _createVNode(_unref(DxColumn), {
                  "data-field": "sendEmail",
                  caption: "Send Email",
                  "cell-template": "sendEmailTemplate",
                  width: "90px",
                  "hiding-priority": 5
                }),
                _createVNode(_unref(DxColumn), {
                  "data-field": "sendSms",
                  caption: "Send SMS",
                  "cell-template": "sendSmsTemplate",
                  width: "90px",
                  "hiding-priority": 4
                })
              ]),
              sendEmailTemplateData: _withCtx(({ data }) => [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(SwitchToggle, {
                    modelValue: data.sendEmail,
                    "onUpdate:modelValue": ($event: any) => ((data.sendEmail) = $event),
                    "read-only": !data.email
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "read-only"])
                ])
              ]),
              sendSmsTemplateData: _withCtx(({ data }) => [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(SwitchToggle, {
                    modelValue: data.sendSms,
                    "onUpdate:modelValue": ($event: any) => ((data.sendSms) = $event),
                    "read-only": !data.mobile
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "read-only"])
                ])
              ]),
              _: 1
            }, 8, ["dataSource"])
          ])
        ])
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: {
          text: 'Send',
          onClick: () => {
            onSendClick();
          },
          disabled: !(willText.value || willEmail.value),
        }
        }, null, 8, ["options"]),
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: {
          text: 'Cancel',
          onClick: () => {
            onCancelClick();
          },
        }
        }, null, 8, ["options"])
      ]),
      _: 1
    }, 8, ["modelValue", "width"]),
    _createVNode(EmailFormModal, {
      modelValue: displayPurchaserEmailModal.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((displayPurchaserEmailModal).value = $event)),
      emailTemplateId: Number(purchaserEmailTemplateId.value),
      "contact-list": purchaserEmailContactIds.value,
      onEmailSent: purchaserEmailModalClosed,
      onCancelPromptAccepted: purchaserEmailModalClosed
    }, null, 8, ["modelValue", "emailTemplateId", "contact-list"]),
    _createVNode(EmailFormModal, {
      modelValue: displayVendorEmailModal.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((displayVendorEmailModal).value = $event)),
      emailTemplateId: Number(vendorEmailTemplateId.value),
      "contact-list": vendorEmailContactIds.value,
      onEmailSent: vendorEmailModalClosed,
      onCancelPromptAccepted: vendorEmailModalClosed
    }, null, 8, ["modelValue", "emailTemplateId", "contact-list"]),
    _createVNode(SMSForm, {
      modelValue: displayPurchaserSMSModal.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((displayPurchaserSMSModal).value = $event)),
      "sms-template": Number(purchaserSMSTemplateId.value),
      "contact-list": purchaserSMSContactIds.value,
      onSmsSent: purchaserSMSModalClosed,
      onCancelPromptAccepted: purchaserSMSModalClosed
    }, null, 8, ["modelValue", "sms-template", "contact-list"]),
    _createVNode(SMSForm, {
      modelValue: displayVendorSMSModal.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((displayVendorSMSModal).value = $event)),
      "sms-template": Number(vendorSMSTemplateId.value),
      "contact-list": vendorSMSContactIds.value
    }, null, 8, ["modelValue", "sms-template", "contact-list"]),
    _createVNode(EmailTemplatesConfigurationModal, {
      modelValue: displayEmailTemplatesModal.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((displayEmailTemplatesModal).value = $event)),
      onConfigurationSelected: emailTemplateSelected,
      accessedFromConfigurationScreen: false
    }, null, 8, ["modelValue"]),
    _createVNode(SmsTextsConfigurationTemplates, {
      modelValue: displaySMSTemplatesModal.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((displaySMSTemplatesModal).value = $event)),
      onTemplateSelected: smsTemplateSelected,
      accessedFromConfigurationScreen: false
    }, null, 8, ["modelValue"])
  ], 64))
}
}

})